import { type ReactNode } from 'react'

import { cn } from '@/utils/commonUtil'

import styles from './StyledContent.module.scss'

type Props = {
  children: ReactNode
  className?: string
  size?: 'sm'
}

export const StyledContent = ({ children, className, size }: Props) => (
  <div className={cn(styles.container, className, { size, styles })}>{children}</div>
)
